export default "<app-color-picker-content startColor=\"#FFFFFF\" \n    (colorChange)=\"onPickColor($event)\"\n    #palette></app-color-picker-content>"